<template>
  <div>
    <div class="row ptb10">
      <div class="col-xs-6 font14">Keypad Artwork Approval Form</div>
      <div class="col-xs-6 text-right">
        <img src="../../assets/images/logo_v2.0.png" width="120px" alt />
      </div>
    </div>
    <table class="table-bordered w100">
      <tr>
        <td class="w70">Product Image</td>
        <td class="w15">Project</td>
        <td class="w15 font13">{{ artwork.project }}</td>
      </tr>
      <tr>
        <td rowspan="25" align="middle" class="text-center">
          <div ref="mypanel" class="inlineb">
            <img :src="checkImg(artwork.img)" :class="$store.getters.hOrV" />
          </div>
        </td>
        <td>Room Type</td>
        <td class="font13">{{ artwork.roomtype }}</td>
      </tr>
      <tr>
        <td>Reference</td>
        <td class="font13">{{artwork.name}}</td>
      </tr>
      <tr>
        <td>Quantity</td>
        <td class="font13">{{ artwork.quantity }}</td>
      </tr>
      <tr class="nob">
        <td>Product SKU</td>
        <td class="font13">{{ artwork.productCode }}</td>
      </tr>
      <tr class="nob">
        <td>Product Series</td>
        <td class="font13">{{ artwork.type.charAt(0).toUpperCase() + artwork.type.slice(1) + ' collection' }}</td>
      </tr>
      <tr class="nob">
        <td>Product Line</td>
        <td class="font13">{{ artwork.productLine || '' }}</td>
      </tr>
      <tr class="nob">
        <td>Product Size</td>
        <td class="font13">{{ artwork.format.replace('v', '').charAt(0).toUpperCase() + artwork.format.replace('v', '').slice(1) }}</td>
      </tr>
      <tr class="nob">
        <td>Finishing</td>
        <td class="font13">{{ productDatabase.MATERIAL_1}} {{ productDatabase.MATERIAL_2 }}</td>
      </tr>
      <tr class="nob" v-if="brushing != ''">
        <td>Brushing</td>
        <td class="font13">{{ brushing }}</td>
      </tr>
      <tr class="nob">
        <td v-if="artwork.type == 'blackjack' || artwork.type == 'alba'">Frame color</td>
        <td v-else>Color</td>
        <td class="font13">{{ frameColor }}</td>
      </tr>
      <tr class="nob" v-if="artwork.type == 'blackjack' || artwork.type == 'alba'">
        <td>Button color</td>
        <td class="font13">{{ buttonColor }}</td>
      </tr>
      <tr class="nob">
        <td>Dimensions</td>
        <td class="font13">{{ dimensions }}</td>
      </tr>
      <tr class="nob">
        <td>Bus</td>
        <td class="font13">{{ artwork.protocol }}</td>
      </tr>
      <tr class="nob">
        <td>Display Color</td>
        <td class="font13">{{displayColor}}</td>
      </tr>
      <tr class="nob">
        <td>Icon Paint Color</td>
        <td class="font13">No Color</td>
      </tr>
      <tr class="nob">
        <td>Text Paint Color</td>
        <td class="font13">No Color</td>
      </tr>
      <tr class="nob">
        <td>Font Type</td>
        <td class="font13">{{ artwork.fontType }}</td>
      </tr>
      <tr class="nob capitalize" v-if="isLeftIcon">
        <td>{{ leftText }} Icon Size</td>
        <td class="font13">{{ $store.state.iconSizeMap[artwork.iconSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="isLeftText">
        <td>{{ leftText }} Text Size</td>
        <td class="font13">{{ $store.state.textSizeMap[artwork.fontSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="notSingle && isRightIcon">
        <td>{{ rightText }} Icon Size</td>
        <td class="font13">{{ $store.state.iconSizeMap[($store.getters.isTriple) ? artwork.tripleRightIconSize : artwork.rightIconSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="notSingle && isRightText">
        <td>{{ rightText }} Text Size</td>
        <td class="font13">{{ $store.state.textSizeMap[($store.getters.isTriple) ? artwork.tripleRightFontSize : artwork.rightFontSize] }}</td>
      </tr>
      <tr>
        <td>Approval Date</td>
        <td class="h50"></td>
      </tr>
      <tr>
        <td>Stamp / Signature</td>
        <td class="h100"></td>
      </tr>
    </table>
    <div class="row ptb10">
      <div class="col-xs-4 font10">
        Ref. ID# {{ artwork.serial_number}}
      </div>
      <div
        class="col-xs-8 font10"
      >
      * Keypad backlight colors are set during installation <br>
      * Metal Finish Variations – Craftsmanship & Uniqueness <br>
      <span style="font-size: 9px;">All Black Nova metal finishes, including anodisation, galvanic bath plating, and hand brushing, are the result of skilled Italian artisanal
      processes that are not fully industrialised. As such, slight tonal or textural variations may occur between individual items or production batches.
      Darker tones tend to highlight these nuances more visibly, lighter shades are generally less affected, while painted finishes usually display the
      greatest consistency. Separate production baths can also yield subtle differences in shade. These natural variations are not to be considered
      defects but rather a hallmark of handcrafted quality, comparable to the veining of marble or the grain of wood, ensuring that no two pieces are ever
      exactly identical. Once installed, changes in room setting and lighting further enhance these distinctions, blending them seamlessly into the
      bespoke and authentic character of each product.</span>
    </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { newMaterials } from "../../store/materials";

export default {
  props: ["artwork"],
  data() {
    return {
      productDatabase: {},
      dim : {
        single : '95x95 mm',
        double: '195x95 mm',
        vdouble: '95x195 mm',
        triple: '295x95 mm',
        vtriple: '95x295 mm'
      }
    };
  },
  computed: {
    brushing() {
      if ((this.artwork.keyColor && this.artwork.keyColor.startsWith('m')) || this.artwork.frameColor.startsWith('m')) {
        return 'Horiozontal';
      } 
      return '';
    },
    frameColor() {
      return Object.values(newMaterials).flat().find(item => item.label === this.artwork.frameColor)?.title || Object.values(newMaterials).flat().find(item => item.label === this.artwork.frameColor)?.title;
    },
    buttonColor() {
      return Object.values(newMaterials).flat().find(item => item.label === this.artwork.keyColor)?.title || Object.values(newMaterials).flat().find(item => item.label === this.artwork.keyColor)?.title;
    },
    displayColor() {
      var a = ['M1'];
      return (a.includes(this.artwork.layout) || 
      (this.$store.getters.isDouble && a.includes(this.artwork.rightLayout)) || 
      (this.$store.getters.isTriple && a.includes(this.artwork.tripleRightLayout))) ? 'White' : 'N/A';
    },
    dimensions() {
      return this.dim[this.artwork.format];
    },
    isLeftIcon() {
      return this.artwork.layoutStyle != 'singleLineText' && this.artwork.layoutStyle != 'doubleLineText' && this.artwork.layoutStyle != 'socket';
    },
    isLeftText() {
      return this.artwork.layoutStyle != 'iconOnly' && this.artwork.layoutStyle != 'socket';
    },
    isRightIcon() {
      var layoutStyle = (this.$store.getters.isTriple) ? this.artwork.tripleRightLayoutStyle : this.artwork.rightLayoutStyle;
      return layoutStyle != 'singleLineText' && layoutStyle != 'doubleLineText' && layoutStyle != 'socket'
    },
    isRightText() {
      var layoutStyle = (this.$store.getters.isTriple) ? this.artwork.tripleRightLayoutStyle : this.artwork.rightLayoutStyle;
      return layoutStyle != 'iconOnly' && layoutStyle != 'socket';
    },
    notSingle() {
      return this.artwork.format != 'single';
    },
    leftText() {
      if (this.$store.getters.isVertical) {
        return 'Top';
      } else if (this.artwork.format != 'single') {
        return 'Left';
      } else {
        return '';
      }
    },
    rightText() {
      if (this.$store.getters.isVertical) {
        return 'Bottom';
      } else {
        return 'Right';
      }
    }
  },
  methods: {
    checkImg(img) {
      if (typeof img == 'undefined') return
      if(img.includes('data:image')) {
        return img;
      } else {
        return this.$store.state.serverURL + '/artwork/' + img + '?' + Date.now()
      }
    },
    async fetchProductDatabase() {
      if (typeof this.artwork.productCode != "undefined" && this.productDatabase) {
        var response = await axios.post("/artwork/productdatabase/" + this.artwork.productCode);
        this.productDatabase = response.data;
      }
    }
  },
  mounted() {
      this.fetchProductDatabase();
  },
  watch:  {
    'artwork.productCode'() {
        this.fetchProductDatabase();
    }
  }
};
</script>